import { computed, defineComponent, onMounted, reactive, ref, watch } from "vue";
import { Form } from "ant-design-vue";
import CompanyTypeSelect from "@/components/company-type-select/index.vue";
import { CompanyPageReq } from "@/views/cooperation/company/company.interface";
import { CompanyService } from "@/views/cooperation/company/company.service";
import { columns } from "./company-select.constant";
import { useEventbus } from "@/core";

export default defineComponent({
  isGlobal: true,
  name: "CompanySelect",
  components: { CompanyTypeSelect },
  props: {
    // 公司ID
    value: { type: String, default: undefined },
    formName: { type: Array, default: () => [] },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const visible = ref(false);
    const selectedKeys = ref<string[]>([]);
    const queryRef = reactive(new CompanyPageReq());
    queryRef.enable = true;
    let isError = ref(false);
    const { resetFields } = Form.useForm(queryRef, reactive({}));
    const { $on } = useEventbus();
    const { data: dataSource, loading, run, refresh, pagination } = CompanyService.usePageApi();
    const valueName = ref('')

    // 通过 companyId 获取 companyName
    const { data: simpleList, run: runSimpleList } = CompanyService.useSimpleListApi();
    watch(()=>props.value,async(n)=>{
      if(n && n.length>0){
        // console.log(simpleList.value?.records.length,simpleList.value?.records)
        if(!simpleList.value?.records.length){
          await runSimpleList();
        }
        const exist = (simpleList.value?.records || []).find((item) => item.id === n);
        valueName.value= exist ? exist.companyName : "";
      }
    },{immediate:true})
    onMounted(async () => {
      await runSimpleList();
    });

    const showModal = () => {
      visible.value = true;
    };

    const closeModal = () => {
      visible.value = false;
    };

    const ok = () => {
      if (selectedKeys.value.length) {
        emit("update:value", selectedKeys.value[0]);
        emit("change", selectedKeys.value[0]);
        isError.value = false;
      }
      closeModal();
    };
    $on("form-error", (data) => {
      if (props.formName.length && data.length) {
        let nameString = props.formName.join(",");
        for (let i = 0; i < data.length; i++) {
          let errorString =
            typeof data[i]["name"] == "string" ? data[i]["name"] : data[i]["name"].join(",");
          if (errorString === nameString) {
            isError.value = true;
            break;
          } else {
            isError.value = false;
          }
        }
      }
    });
    const search = async () => {
      selectedKeys.value = [];
      queryRef.current = 1;
      await run(queryRef);
    };

    const reset = async () => {
      resetFields();
      await search();
    };

    const onTableChange = async (pagination) => {
      queryRef.current = pagination.current;
      queryRef.size = pagination.pageSize;
      await run(queryRef);
    };

    const onRadioChange = ({item}) => {
      selectedKeys.value = [item[0].id];
      valueName.value = item[0].companyName;
    };

    const removeSelected = () => {
      emit("update:value", undefined);
      emit("change", undefined);
      isError.value = true;
    };

    onMounted(async () => {
      await search();
    });

    watch(
      () => props.value,
      () => {
        selectedKeys.value = props.value ? [props.value] : [];
      },
      { immediate: true }
    );

    return {
      visible,
      showModal,
      closeModal,
      ok,
      selectedKeys,
      valueName,
      queryRef,
      loading,
      dataSource,
      columns,
      pagination,
      refresh,
      reset,
      search,
      onTableChange,
      onRadioChange,
      removeSelected,
      isError,
    };
  },
});
